import BlockedBrokerPage from './BlockedBrokerPage';

export default BlockedBrokerPage;
